import { render } from "./TheHero.vue?vue&type=template&id=2f6cb14d&scoped=true"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"

import "./TheHero.vue?vue&type=style&index=0&id=2f6cb14d&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6cb14d"]])

export default __exports__